import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./pages/AuthCallback";
import Account from "./pages/Account";
import AdminDashboard from "./pages/AdminDashboard";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Rates from "./components/Rates";
import BuyLease from "./components/BuyLease";
import RewardScheme from "./components/RewardScheme";
import EasyEMI from "./components/EasyEMI";
import Products from "./components/Products";
import Business from "./components/Business";
import Contact from "./components/Contact";
import LuckyDraw from "./components/LuckyDraw";
import HallOfFame from "./components/HallOfFame";
import Reviews from "./components/Reviews";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="selection-gold bg-ink text-foreground">
      <Navbar />
      <main>
        <Hero />
        <Rates />
        <BuyLease />
        <RewardScheme />
        <EasyEMI />
        <Products />
        <Business />
        <Contact />
        <LuckyDraw />
        <HallOfFame />
        <Reviews />
      </main>
      <Footer />
    </div>
  );
};

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
